// Constants
export const AUTH = {
  CLEAR_STATUS: 'CLEAR_STATUS',
  LOGOUT_ERROR: 'LOGOUT_ERROR',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGIN_USER_ERROR: 'LOGIN_USER_ERROR',
  LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
  REFRESH_TOKEN_ERROR: 'REFRESH_TOKEN_ERROR',
  REFRESH_EXPIRED: 'REFRESH_EXPIRED',
  REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS',
  INVALID_TOKEN: 'INVALID_TOKEN',
  UPDATE_ACCESS_TOKEN_TIME: 'UPDATE_ACCESS_TOKEN_TIME',
  ADD_PRACTITIONER: 'ADD_PRACTITIONER',
  PENDING_REFRESH_TOKEN: 'PENDING_REFRESH_TOKEN'
};

// Reducer
const initialState = {
  practitioner: {},
  isAuthenticated: false,
  token: null,
  refreshToken: null,
  statusText: null,
  isTokenExpired: false,
  role: null,
  exp: null,
  nbf: null,
  pendingRefreshToken: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AUTH.LOGIN_USER_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.data.access_token,
        refreshToken: action.payload.data.refresh_token,
        isTokenExpired: false,
        statusText: null,
        role: action.payload.role
      };
    }
    case AUTH.LOGIN_USER_ERROR: {
      return {
        ...state,
        statusText: action.payload,
        isTokenExpired: false
      };
    }
    case AUTH.REFRESH_TOKEN_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.access_token,
        refreshToken: action.payload.refresh_token,
        isTokenExpired: false
      };
    }
    case AUTH.REFRESH_TOKEN_ERROR: {
      return {
        ...state,
        isAuthenticated: false,
        token: null,
        refreshToken: null
      };
    }
    case AUTH.PENDING_REFRESH_TOKEN: {
      return {
        ...state,
        pendingRefreshToken: action.payload
      };
    }
    case AUTH.LOGOUT_SUCCESS: {
      return {
        ...state,
        practitioner: {},
        isAuthenticated: false,
        token: null,
        refreshToken: null,
        exp: null,
        iat: null
      };
    }
    case AUTH.LOGOUT_ERROR: {
      return {
        ...state,
        practitioner: {},
        isAuthenticated: false,
        token: null,
        refreshToken: null
      };
    }
    case AUTH.CLEAR_STATUS: {
      return {
        ...state,
        statusText: null
      };
    }
    case AUTH.REFRESH_EXPIRED: {
      return { ...state, isTokenExpired: true, pendingRefreshToken: false };
    }

    case AUTH.UPDATE_ACCESS_TOKEN_TIME: {
      let { exp, nbf } = action.payload;

      return {
        ...state,
        exp: parseInt(exp + '000'),
        nbf: parseInt(nbf + '000')
      };
    }

    case AUTH.ADD_PRACTITIONER: {
      return { ...state, practitioner: action.payload };
    }

    default:
      return state;
  }
};
